export default __webpack_public_path__ + "static/media/BhBotAvatar.a21501e5.png";